import { faCheck, faEdit } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Button } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

import DownloadLinkButton from './DownloadLinkButton';

interface IEventImportCardActionsProps {
  importer: Importer;
}

/** The card's actions in reading order, with the next step for the import last. */
function EventImportCardActions({ importer }: Readonly<IEventImportCardActionsProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const localUrl = useLocalUrl();
  const state = importer.get('state');
  const wizardUrl = localUrl(importer.getItemUrl());

  return (
    <Flex gap={theme.spacing['2']} justify={'flex-end'} wrap={'wrap'}>
      {state === 'draft' ? (
        <Button link={wizardUrl} prefix={<FontAwesomeIcon icon={faCheck} size={'2x'} />}>
          {t('Finish')}
        </Button>
      ) : (
        <DownloadLinkButton href={importer.downloadUrl} label={t('Download import file')} />
      )}
      {state === 'failed' && (
        <Button
          link={wizardUrl}
          prefix={<FontAwesomeIcon icon={faEdit} size={'2x'} />}
          type={'primary'}
        >
          {t('Edit import')}
        </Button>
      )}
    </Flex>
  );
}

export default observer(EventImportCardActions);
